import { render } from "./LoginRegister.vue?vue&type=template&id=478f3dc2&scoped=true"
const script = {}

import "./LoginRegister.vue?vue&type=style&index=0&id=478f3dc2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Documents\\projects\\termounity\\public\\templates\\project\\Controllers\\Order\\Main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478f3dc2"]])

export default __exports__